import { defineMessages } from 'react-intl';

const messages = defineMessages({
  shipmentOptionsTitle: {
    defaultMessage: 'Shipment Options',
    description: 'otherShippingOptions.shipmentOptions',
    id: 'eOGUYD',
  },
  notificationOptionsTitle: {
    defaultMessage: 'Notification Options',
    description: 'otherShippingOptions.notificationOptions',
    id: 'ZL2DGc',
  },
  deliveryOptionsTitle: {
    defaultMessage: 'Delivery Options',
    description: 'otherShippingOptions.deliveryOptions',
    id: 'ne8nwv',
  },
  labelOptionsTitle: {
    defaultMessage: 'Label Options',
    description: 'otherShippingOptions.labelOptions',
    id: 'TUHPwI',
  },
  marketplaceOptionsTitle: {
    defaultMessage: 'Marketplace Options',
    description: 'otherShippingOptions.marketplaceOptions',
    id: 'aR+OSY',
  },
  shippingAccountLabel: {
    defaultMessage: 'Shipping Account',
    description: 'otherShippingOptions.shippingAccount',
    id: 'wYFzKy',
  },
  accountNumberLabel: {
    defaultMessage: 'Account #',
    description: 'otherShippingOptions.accountNumber',
    id: 'q5lqNN',
  },
  countryLabel: {
    defaultMessage: 'Country',
    description: 'otherShippingOptions.billingCountry',
    id: 'nM3XOW',
  },
  postalCodeLabel: {
    defaultMessage: 'Postal Code',
    description: 'otherShippingOptions.postalCode',
    id: '8i8Jw6',
  },
  externalFulfillmentOptionsTitle: {
    defaultMessage: 'Fulfillment Options',
    description: 'Provides additional options for orders intended for 3rd party fulfillment',
    id: 'FmVK/r',
  },
  windsorFrameworkOptionsTitle: {
    defaultMessage: 'Northern Ireland Requirements <popover></popover>',
    description: 'Title section that provides additional options for orders that have to apply for Windsor Framework',
    id: 'EU7zJE',
  },
  serviceLevelsTitle: {
    defaultMessage: 'Service Levels <popover></popover>',
    description: 'Label for service levels section in other shipping options',
    id: 'WPMSfT',
  },
  serviceLevelPopoverContent: {
    defaultMessage: 'If this value is empty, service level will be assigned from OBA contract',
    description: 'Content for the popover that provides additional info for Service Level',
    id: 'Oo1Ok8',
  },
  windsorFrameworkPopoverTitle: {
    defaultMessage: 'Northern Ireland Requirements',
    description: 'Title for the popover that provides additional info for Windsor Framework',
    id: 'U9Zybw',
  },
  windsorFrameworkPopoverContent: {
    defaultMessage: 'If you are unsure about the requirements for this shipment, review our Windsor framework article for details.',
    description: 'Content for the popover that provides additional info for Windsor Framework',
    id: 'i9Digx',
  },
  windsorFrameworkPopoverLinkText: {
    defaultMessage: 'View article',
    description: 'Link text in the popover link to Windsor Framework information page',
    id: 'yvC6Dr',
  },
});

export default messages;
